import clientStorage from "../utils/client-storage";
import {creativeName} from "../utils/creative";
import Creative from "../photolab/Creative";
import creativeGroups from "../photolab/config/groups";
import Processing from "../photolab/Processing";
import {CreativeTimeoutError} from "../photolab/handlers/helpers";
import processingManager from "../photolab/ProcessingManager";
import {getCollectResultsService} from "../services/collectResults";
import {getWebAnalyticsService} from "../services/webAnalytics";
import {getSignalsService} from "../services/signals";
import {getTimingsService} from "../services/timings";
import {getHitsService} from "../services/hits";
import {webviewAnalyticsEvent} from "@vicman-wi/webview-api/functions/app/analytics";

export const userEvents = {
  PAGE: "page",

  // юзер нажал на "попробовать другое фото"
  // параметры: page (страница: create, result, error)
  HOME_BUTTON_CLICK: "home_button_click",

  // юзер выбрал фото
  // параметры: page (страница: index, error, result)
  PHOTO_SELECT: "photo_select",

  // юзер успешно загрузил фото
  PHOTO_UPLOADED: "photo_uploaded",

  // юзер неуспешно загрузил фото
  PHOTO_UPLOAD_FAILED: "photo_upload_failed",

  TAB_SELECT: "tab_select",
  TAB_REFRESH: "tab_refresh",

  PROCESSING_PROCESSED: "processing_processed",
  PROCESSING_FAILED: "processing_failed",

  CREATIVE_STARTED: "creative_started",
  CREATIVE_PROCESSED: "creative_processed",
  CREATIVE_FAILED: "creative_failed",

  CREATIVE_VIEW: "creative_view",

  DOWNLOAD: "download",

  GET_APP_CLICK: "get_app_click",

  RATEAPP_DIALOG_SHOW: "rateapp_dialog_show",
  RATEAPP_DIALOG_RATE: "rateapp_dialog_rate",
  RATEAPP_DIALOG_SKIP: "rateapp_dialog_skip",

  COMPONENT_ERROR: "component_error",
  JS_GLOBAL_ERROR: "js_global_error",

  CHANGE_MASK_CLICK: "change_mask_click",

  FRONTEND_WATERMARK_FAILED: "frontend_watermark_failed",

  RESUBSCRIBE_BANNER_SHOW: "resubscribe_banner_show",
  RESUBSCRIBE_CLICK: "resubscribe_click",

  FULL_SIZE_RESULTS_CLICK: "full_size_results_click",
  FULL_SIZE_PROMOTION_SHOW: "full_size_promotion_show",
  FULL_SIZE_PROMOTION_SKIP_CLICK: "full_size_promotion_skip_click",
  FULL_SIZE_PROMOTION_DEEPLINK_CLICK: "full_size_promotion_deeplink_click",

  LCP_REPORT: "lcp_report",
};

export const hits = {
  TAB_OPENED: 0,
  PHOTO_SELECT: 8879,
  PHOTO_UPLOADED: 8880,
  PAGE_MASK_BEFORE_PROCESSING: 8881,
  SAVE_MASK_BEFORE_PROCESSING: 8883,
  SKIP_MASK_BEFORE_PROCESSING: 8884,
  PROCESSING_PROCESSED: 8885,
  PROCESSING_FAILED: 8886,
  PROCESSING_FAILED_BY_PHOTOLAB: 8976,
  PROCESSING_FAILED_ON_RESULT_PAGE: 8887,
  PROCESSING_TIMEOUT: 8984,

  DOWNLOAD: 8888,
  FIRST_DOWNLOAD_BY_CLIENT: 9010,
  FIRST_DOWNLOAD_BY_PROCESSING: 9011,
  FIRST_DOWNLOAD_BY_TEMPLATE: 9013,

  PAGE_MASK_AFTER_RESULT: 8889,
  SAVE_MASK_AFTER_RESULT: 8890,
  SKIP_MASK_AFTER_RESULT: 8891,
  GET_APP_CLICK: 8935,
  RATEAPP_DIALOG_SHOW: 8936,
  RATEAPP_DIALOG_RATE: 8937,
  RATEAPP_DIALOG_SKIP: 8938,
  RATEAPP_DIALOG_INAPP_RESPONSE_0: 8939,
  RATEAPP_DIALOG_INAPP_RESPONSE_1: 8940,
  RATEAPP_DIALOG_INAPP_RESPONSE_2: 8941,
  RATEAPP_DIALOG_INAPP_RESPONSE_3: 8942,
  INDEX_VISIT_WEB_DESKTOP: 9053,
  INDEX_VISIT_WEB_MOBILE: 9054,
  INDEX_VISIT_WEBVIEW: 8978,
  NATIVE_ADS_PRELOAD: 8981,
  NATIVE_ADS_SHOW_REQUEST: 8982,
  NATIVE_ADS_SHOWN: 8983,
  START_PENDING_CREATIVE: 8980,
  FIRST_CLICK_TAB: 8985,
  FIRST_CLICK_REFRESH_CREATIVE: 8986,

  FRONTEND_WATERMARK_STARTED: 8988,
  FRONTEND_WATERMARK_PROCESSED: 8989,
  FRONTEND_WATERMARK_FAILED: 8990,
  FRONTEND_WATERMARK_FAILED_TIMEOUT: 9042,
  COMPONENT_ERROR: 8993,
  START_PENDING_PROCESSING: 8991,
  START_AUTO_PROCESSING: 8992,
  DOWNLOAD__AUTO_PROCESSING: 8994,
  ANALYTICS_ERROR: 9027,

  FORCE_REDIRECT_PROCESSING: 9039,

  MASK_UPDATED: 9040,

  REQUEST_PHOTOLAB_SIGN_FAIL: 9049,
  REQUEST_PHOTOLAB_SIGN_ALT_FAIL: 9050,

  DOWNLOAD_WITH_WATERMARK: 9056,
  DOWNLOAD_WITHOUT_WATERMARK: 9057,

  WATERMARK_POPUP_REMOVE_CLICK: 9058,
  WATERMARK_POPUP_KEEP_CLICK: 9059,
  jsGlobalError: 9602,

  D22_CACHE_HIT: 9635,
  D22_CACHE_MISS: 9636,
};

export const signals = {
  photoSelectClick: "photo_select_click",
  photoSelected: "photo_selected",
  processingStarted: "processing_started",
  processingProcessed: "processing_processed",
  processingFailed: "processing_failed",
  processingFailedPhotolab: "processing_failed_photolab",
  download: "download",
  jsGlobalError: "js_global_error",
};

export default {
  error: (event) => {
    if (/^Script error\./i.test(event.message)) {
      getSignalsService().send("error_se", {
        force: true,
      });
      return;
    }

    getSignalsService().send("error", {
      force: true,
    });

    getWebAnalyticsService().send("error", {
      event: "error",
      url: window.location.href,
      error: {
        name: event.error?.name,
        code: event.error?.code,
        message: event.error?.message,
        stack: event.error?.stack,
      },
      context: {
        type: event.type,
        file: event.filename,
        line: event.lineno,
        column: event.colno,
        message: event.message,
      },
    }, {
      force: true,
    });
  },
  unhandledRejection: (event) => {
    getSignalsService().send("error", {
      force: true,
    });

    getWebAnalyticsService().send("error", {
      event: "unhandledrejection",
      url: window.location.href,
      error: {
        name: event.reason?.name,
        code: event.reason?.code,
        message: event.reason?.message,
        stack: event.reason?.stack,
      },
    }, {
      force: true,
    });
  },
  componentError: (error, errorInfo) => {
    getSignalsService().send("error", {
      force: true,
    });

    getWebAnalyticsService().send("error", {
      event: "component_error",
      url: window.location.href,
      error: {
        name: error?.name,
        code: error?.code,
        message: error?.message,
        stack: error?.stack,
        componentStack: errorInfo?.componentStack,
      },
    }, {
      force: true,
    });

    getHitsService().send(hits.COMPONENT_ERROR, {
      force: true,
    });
  },
  appEnterBackground: (place, count) => {
    webviewAnalyticsEvent("app_enter_background", {
      value1: clientStorage.getSelectedPhotosAmount(),
      value2: count,
      value6: place,
    });
  },
  photoSelect: () => {
    webviewAnalyticsEvent("photo_select", {
      value1: clientStorage.getSelectedPhotosAmount(),
    });
  },
  photoUpload: (face) => {
    webviewAnalyticsEvent("photo_upload", {
      value1: clientStorage.getSelectedPhotosAmount(),
      value2: face.hairColor,
      value3: face.skinColor,
      value4: face.gender,
    });

    getSignalsService().send(signals.processingStarted);
  },
  photoUploadError: (err) => {
    webviewAnalyticsEvent("photo_upload_error", {
      value1: clientStorage.getSelectedPhotosAmount(),
      value2: err.code,
      value3: err.message,
    });
  },
  photoUploaded: (file) => {
    // getHitsService().send(hits.PHOTO_UPLOADED);
    getWebAnalyticsService().send(userEvents.PHOTO_UPLOADED, {
      file_id: file.id,
      file_url: file.url,
      uploaded_at: Date.now(),
    });
  },
  templateSelect: (processing, creative) => {
    const positionInGroup = processing
      .getCreativesInGroup(creative.group)
      .findIndex(c => c.id === creative.id);

    webviewAnalyticsEvent("template_select", {
      value1: clientStorage.getSelectedPhotosAmount(),
      value2: processing.creatives.filter((c) => c.isFinished).length,
      value3: creative.getExtra("is_pro", false) ? "pro" : creative.group,
      value4: creativeName(creative),
      value5: !creative.getExtra(Creative.EXTRA_VIEW_OPENED, false) ? 1 : 0,
      data: {
        wt_npp: {
          group_pos: processing.groups.indexOf(creative.group) + 1,
          template_pos: positionInGroup + 1
        }
      }
    });

    getWebAnalyticsService().send(userEvents.TAB_SELECT, {
      group: creative.getExtra("is_pro", false) ? "pro" : creative.group,
      gender: processingManager.processing.getExtra("gender"),
      file_id: processingManager.processing.file.id,
      template_id: creativeName(creative),
      is_new_client: window.clientConfig.isNew,
    });
  },
  templateShow: (processing, creative) => {
    const positionInGroup = processing
      .getCreativesInGroup(creative.group)
      .findIndex(c => c.id === creative.id);

    webviewAnalyticsEvent("template_show", {
      value1: clientStorage.getSelectedPhotosAmount(),
      value2: processing.creatives.filter((c) => c.isFinished).length,
      value3: creative.getExtra("is_pro", false) ? "pro" : creative.group,
      value4: creativeName(creative),
      data: {
        wt_npp: {
          group_pos: processing.groups.indexOf(creative.group) + 1,
          template_pos: positionInGroup + 1
        }
      }
    });

    getWebAnalyticsService().send(userEvents.CREATIVE_VIEW, {
      group: creative.getExtra("is_pro", false) ? "pro" : creative.group,
      gender: processing.getExtra("gender"),
      file_id: processing.file.id,
      template_id: creativeName(creative),
      alias: creative.getExtra(Creative.EXTRA_ALIAS, ""),
      position: processing.groups.indexOf(creative.group) + 1,
      position_in_group: positionInGroup + 1,
      is_refresh: creative.isRefreshed,
      is_alt_mask: processing.getExtra(Processing.EXTRA_IS_FORKED, false),
      is_new_client: window.clientConfig.isNew,
    });
  },
  adBannerShow: (value, bannerId, link) => {
    webviewAnalyticsEvent("ad_banner_show", {
      value1: value,
      value2: bannerId,
      value3: "processing",
      value4: clientStorage.getProcessingBannerRotationIndex(value),
      value5: clientStorage.getSelectedPhotosAmount(),
      value6: clientStorage.getProcessedPhotosAmount(),
      data: {
        wt_npp: {
          link
        }
      }
    });
  },
  adBannerClick: (value, bannerId, link) => {
    webviewAnalyticsEvent("ad_banner_click", {
      value1: value,
      value2: bannerId,
      value3: "processing",
      value4: clientStorage.getProcessingBannerRotationIndex(value),
      value5: clientStorage.getSelectedPhotosAmount(),
      value6: clientStorage.getProcessedPhotosAmount(),
      data: {
        wt_npp: {
          link
        }
      }
    });
  },
  adBannerClose: (value, bannerId, link) => {
    webviewAnalyticsEvent("ad_banner_close", {
      value1: value,
      value2: bannerId,
      value3: "processing",
      value4: clientStorage.getProcessingBannerRotationIndex(value),
      value5: clientStorage.getSelectedPhotosAmount(),
      value6: clientStorage.getProcessedPhotosAmount(),
      data: {
        wt_npp: {
          link
        }
      }
    });
  },
  hairColorSelect: (color, style) => {
    webviewAnalyticsEvent("hair_color_select", {
      value1: clientStorage.getSelectedPhotosAmount(),
      value2: color,
      value3: style.replace(/\s+/g, "_"),
    });
  },
  generationStart: (processing, creative) => {
    webviewAnalyticsEvent("generation_start", {
      value1: clientStorage.getSelectedPhotosAmount(),
      value2: processing.creatives.filter((c) => c.isFinished).length,
      value3: creative.getExtra("is_pro", false) ? "pro" : creative.group,
      value4: creativeName(creative),
    });

    getWebAnalyticsService().send(userEvents.CREATIVE_STARTED, {
      group: creative.getExtra("is_pro", false) ? "pro" : creative.group,
      template_id: creativeName(creative),
      seed: creative.getExtra("seed", 0),
    });

    if (window.clientConfig.features.isAutoStartCreatives) {
      getHitsService().send(hits.START_AUTO_PROCESSING, {
        force: true,
      });
    } else {
      getHitsService().send(hits.START_PENDING_PROCESSING, {
        force: true,
      });
    }
  },
  generationFinish: (processing, creative) => {
    webviewAnalyticsEvent("generation_finish", {
      value1: clientStorage.getSelectedPhotosAmount(),
      value2: processing.creatives.filter((c) => c.isFinished).length,
      value3: creative.getExtra("is_pro", false) ? "pro" : creative.group,
      value4: creativeName(creative),
    });

    getWebAnalyticsService().send(userEvents.CREATIVE_PROCESSED, {
      group: creative.getExtra("is_pro", false) ? "pro" : creative.group,
      template_id: creativeName(creative),
      processing_time: Date.now() - creative.getExtra(Creative.EXTRA_STARTED_AT),
      seed: creative.getExtra("seed", 0),
    });

    if (!creative.inGroup(creativeGroups.COMMON)) {
      getCollectResultsService().send({
        creativeId: creative.id,
        templateId: creativeName(creative),
        inputData: [{
          url: processing.file.url,
          skeleton_data: processing.getSkeleton(),
        }],
        outputData: [{url: creative.result}],
        isDownloaded: false,
        extra: {
          gender: processing.getExtra("gender"),
        },
      });
    }
  },
  generationError: (processing, creative) => {
    webviewAnalyticsEvent("generation_error", {
      value1: clientStorage.getSelectedPhotosAmount(),
      value2: processing.creatives.filter((c) => c.isFinished).length,
      value3: creative.error.code,
      value4: creative.error.message,
    });

    getWebAnalyticsService().send(userEvents.CREATIVE_FAILED, {
      group: creative.getExtra("is_pro", false) ? "pro" : creative.group,
      template_id: creativeName(creative),
      processing_time: Date.now() - creative.getExtra(Creative.EXTRA_STARTED_AT),
      error: creative.error,
      photo: processing.file.url,
      seed: creative.getExtra("seed", 0),
    });

    if (!creative.inGroup(creativeGroups.COMMON)) {
      getCollectResultsService().send({
        creativeId: creative.id,
        templateId: creativeName(creative),
        inputData: [{
          url: processing.file.url,
          skeleton_data: processing.getSkeleton(),
        }],
        outputData: [{error: creative.error}],
        isDownloaded: false,
        extra: {
          gender: processing.getExtra("gender"),
        },
      });
    }
  },
  saveAndShare: (processing, creative, provider) => {
    const positionInGroup = processing
      .getCreativesInGroup(creative.group)
      .findIndex(c => c.id === creative.id);

    webviewAnalyticsEvent("save_and_share", {
      value1: clientStorage.getSelectedPhotosAmount(),
      value2: processing.creatives.filter((c) => c.isFinished).length,
      value3: creative.getExtra("is_pro", false) ? "pro" : creative.group,
      value4: creativeName(creative),
      value5: provider,
      data: {
        wt_npp: {
          group_pos: processing.groups.indexOf(creative.group) + 1,
          template_pos: positionInGroup + 1
        }
      }
    });

    if (window.clientConfig.isPro) {
      if (processing.getExtra(Processing.EXTRA_PRO_WATERMARK_SHOULD_BE_REMOVED, false)) {
        getHitsService().send(hits.DOWNLOAD_WITHOUT_WATERMARK);
      } else {
        getHitsService().send(hits.DOWNLOAD_WITH_WATERMARK);
      }
    }

    if (provider === "download") {
      getHitsService().send(hits.DOWNLOAD);

      getWebAnalyticsService().send(userEvents.DOWNLOAD, {
        group: creative.getExtra("is_pro", false) ? "pro" : creative.group,
        gender: processing.getExtra("gender"),
        file_id: processing.file.id,
        template_id: creativeName(creative),
        alias: creative.getExtra(Creative.EXTRA_ALIAS, ""),
        position: processing.groups.indexOf(creative.group) + 1,
        position_in_group: positionInGroup + 1,
        is_refresh: creative.isRefreshed,
        is_alt_mask: processing.getExtra(Processing.EXTRA_IS_FORKED, false),
        is_new_client: window.clientConfig.isNew,
        seed: creative.getExtra("seed", 0),
      });

      getCollectResultsService().send({
        creativeId: creative.id,
        templateId: creativeName(creative),
        inputData: [{
          url: processing.file.url,
          skeleton_data: processing.getSkeleton(),
        }],
        outputData: [{error: creative.error}],
        isDownloaded: true,
        extra: {
          gender: processing.getExtra("gender"),
        },
      });

      if (!processing.hasExtra("signal_download_is_sent")) {
        processing.setExtra("signal_download_is_sent", true);
        getSignalsService().send(signals.download);
      }
    }
  },
  anotherPhotoButtonTap: (processing, group) => {
    webviewAnalyticsEvent("another_photo_button_tap", {
      value1: clientStorage.getSelectedPhotosAmount(),
      value2: processing.creatives.filter((c) => c.isFinished).length,
      value3: group,
      value4: group,
    });
  },
  choosePhotoButtonTap: () => {
    getSignalsService().send(signals.photoSelectClick);
    webviewAnalyticsEvent("choose_photo_button_tap", {});
  },
  getAppClick: (page) => {
    getHitsService().send(hits.GET_APP_CLICK);
    getWebAnalyticsService().send(userEvents.GET_APP_CLICK, {page});
  },
  photoSelected: () => {
    getHitsService().send(hits.PHOTO_SELECT);
    getSignalsService().send(signals.photoSelected);
  },
  photoSelectedWebAnalytics: (page) => {
    getWebAnalyticsService().send(userEvents.PHOTO_SELECT, {page});
  },
  processingFailedOnResultPage: () => {
    getHitsService().send(hits.PROCESSING_FAILED_ON_RESULT_PAGE);
  },
  pageMaskAfterResult: () => {
    getHitsService().send(hits.PAGE_MASK_AFTER_RESULT);
  },
  pageMaskBeforeProcessing: () => {
    getHitsService().send(hits.PAGE_MASK_BEFORE_PROCESSING);
  },
  maskUpdated: () => {
    getHitsService().send(hits.MASK_UPDATED);
  },
  skipMaskAfterResult: () => {
    getHitsService().send(hits.SKIP_MASK_AFTER_RESULT);
  },
  skipMaskBeforeProcessing: () => {
    getHitsService().send(hits.SKIP_MASK_BEFORE_PROCESSING);
  },
  saveMaskAfterResult: () => {
    getHitsService().send(hits.SAVE_MASK_AFTER_RESULT);
  },
  saveMaskBeforeProcessing: () => {
    getHitsService().send(hits.SAVE_MASK_BEFORE_PROCESSING);
  },
  changeMaskClick: (params) => {
    getWebAnalyticsService().send(userEvents.CHANGE_MASK_CLICK, params);
  },
  nativeAdsShown: () => {
    getHitsService().send(hits.NATIVE_ADS_SHOWN);
  },
  nativeAdsPreload: () => {
    getHitsService().send(hits.NATIVE_ADS_PRELOAD);
  },
  nativeAdsShowRequest: () => {
    getHitsService().send(hits.NATIVE_ADS_SHOW_REQUEST);
  },
  firstClickRefreshCreative: () => {
    getHitsService().send(hits.FIRST_CLICK_REFRESH_CREATIVE);
  },
  firstDownloadByTemplate: () => {
    getHitsService().send(hits.FIRST_DOWNLOAD_BY_TEMPLATE);
  },
  firstDownloadByProcessing: () => {
    getHitsService().send(hits.FIRST_DOWNLOAD_BY_PROCESSING);
  },
  firstDownloadByClient: () => {
    getHitsService().send(hits.FIRST_DOWNLOAD_BY_CLIENT);
  },
  startPendingCreative: () => {
    getHitsService().send(hits.START_PENDING_CREATIVE);
  },
  rateAppDialogShow: () => {
    getHitsService().send(hits.RATEAPP_DIALOG_SHOW);
    getWebAnalyticsService().send(userEvents.RATEAPP_DIALOG_SHOW);
  },
  rateAppDialogRate: () => {
    getHitsService().send(hits.RATEAPP_DIALOG_RATE);
    getWebAnalyticsService().send(userEvents.RATEAPP_DIALOG_RATE);
  },
  rateAppDialogSkip: () => {
    getHitsService().send(hits.RATEAPP_DIALOG_SKIP);
    getWebAnalyticsService().send(userEvents.RATEAPP_DIALOG_SKIP);
  },
  rateAppDialogInappResponse: (res) => {
    switch (parseInt(res)) {
      case 0: getHitsService().send(hits.RATEAPP_DIALOG_INAPP_RESPONSE_0); return;
      case 1: getHitsService().send(hits.RATEAPP_DIALOG_INAPP_RESPONSE_1); return;
      case 2: getHitsService().send(hits.RATEAPP_DIALOG_INAPP_RESPONSE_2); return;
      case 3: getHitsService().send(hits.RATEAPP_DIALOG_INAPP_RESPONSE_3); return;
      default:
        return;
    }
  },
  watermarkPopupKeepClick: () => {
    getHitsService().send(hits.WATERMARK_POPUP_KEEP_CLICK);
  },
  watermarkPopupRemoveClick: () => {
    getHitsService().send(hits.WATERMARK_POPUP_REMOVE_CLICK);
  },
  processingProcessed: (processing) => {
    const elapsedMs = Date.now() - processing.getExtra(Processing.EXTRA_STARTED_AT);

    getTimingsService().send(window.appConfig.project.name, elapsedMs);

    getWebAnalyticsService().send(userEvents.PROCESSING_PROCESSED, {elapsed_time_ms: elapsedMs});

    getSignalsService().send(signals.processingProcessed);

    getHitsService().send(hits.PROCESSING_PROCESSED);
  },
  processingFailed: (processing, creative) => {
    const elapsedMs = Date.now() - processing.getExtra(Processing.EXTRA_STARTED_AT);

    getWebAnalyticsService().send(userEvents.PROCESSING_FAILED, {elapsed_time_ms: elapsedMs});

    if (creative.error && creative.error.type === "photolab") {
      getSignalsService().send(signals.processingFailedPhotolab);
      getHitsService().send(hits.PROCESSING_FAILED_BY_PHOTOLAB);
    } else {
      getSignalsService().send(signals.processingFailed);
      getHitsService().send(hits.PROCESSING_FAILED);
    }
  },

  processingTimeout: () => {
    getHitsService().send(hits.PROCESSING_TIMEOUT);
  },
  firstClickTab: () => {
    getHitsService().send(hits.FIRST_CLICK_TAB);
  },
  d22CacheHit: () => {
    getHitsService().send(hits.D22_CACHE_HIT, {
      force: true,
    });
  },
  d22CacheMiss: () => {
    getHitsService().send(hits.D22_CACHE_MISS, {
      force: true,
    });
  },
  frontendWatermarkStarted: () => {
    getHitsService().send(hits.FRONTEND_WATERMARK_STARTED);
  },
  frontendWatermarkProcessed: () => {
    getHitsService().send(hits.FRONTEND_WATERMARK_PROCESSED);
  },
  frontendWatermarkFailed: (error) => {
    getHitsService().send(hits.FRONTEND_WATERMARK_FAILED);
    getWebAnalyticsService().send(userEvents.FRONTEND_WATERMARK_FAILED, {error: error.message});

    if (error instanceof CreativeTimeoutError) {
      getHitsService().send(hits.FRONTEND_WATERMARK_FAILED_TIMEOUT);
    }
  },
  forceRedirectProcessing: () => {
    getHitsService().send(hits.FORCE_REDIRECT_PROCESSING);
  },
  visit: (page) => {
    getWebAnalyticsService().send(userEvents.PAGE, {page});

    if (window.clientConfig.isWebDesktop && page === "index") {
      getHitsService().send(hits.INDEX_VISIT_WEB_DESKTOP);
    } else if (window.clientConfig.isWebMobile && page === "index") {
      getHitsService().send(hits.INDEX_VISIT_WEB_MOBILE);
    }
  },
  fullSizeResultsClick: (page) => {
    getWebAnalyticsService().send(userEvents.FULL_SIZE_RESULTS_CLICK, {page});
  },
  fullSizePromotionShow: (params) => {
    getWebAnalyticsService().send(userEvents.FULL_SIZE_PROMOTION_SHOW, params);
  },
  fullSizePromotionDeeplinkClick: (params) => {
    getWebAnalyticsService().send(userEvents.FULL_SIZE_PROMOTION_DEEPLINK_CLICK, params);
  },
  fullSizePromotionSkipClick: (params) => {
    getWebAnalyticsService().send(userEvents.FULL_SIZE_PROMOTION_SKIP_CLICK, params);
  },
  resubscribeBannerShow: () => {
    getWebAnalyticsService().send(userEvents.RESUBSCRIBE_BANNER_SHOW);
  },
  resubscribeClick: () => {
    getWebAnalyticsService().send(userEvents.RESUBSCRIBE_CLICK);
  },
  lcpReport: (metric) => {
    getWebAnalyticsService().send(userEvents.LCP_REPORT, {
      value: metric.value,
      delta: metric.delta,
      rating: metric.rating,
    });
  },
};
